"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GravyBinder = void 0;
var GravyBinder = /** @class */ (function () {
    function GravyBinder(scope, root, config) {
        var _this = this;
        this.config = config;
        this.outwardBindingActions = {};
        this.appliedBindings = [];
        this.loopByQuery = function (query, action) {
            var elements = _this.root.querySelectorAll(query);
            // tslint:disable-next-line: prefer-for-of
            for (var i = 0; i < elements.length; ++i) {
                var element = elements[i];
                action(element);
            }
        };
        this.setDynamic = function (property, value) {
            _this.scope.$binderWorkingValue = value;
            return Function(property + " = this.$binderWorkingValue").call(_this.scope);
        };
        this.getDynamic = function (property) { return _this.compileGetter(property).call(_this.scope); };
        this.compileGetter = function (property) { return Function("return " + property); };
        this.updateInputBindings = function () {
            return _this.loopByQuery('[data-in]', function (e) {
                if (e.type === 'checkbox')
                    _this.setDynamic(e.dataset.in, e.checked);
                else if (e.type == 'radio') {
                    if (e.checked)
                        _this.setDynamic(e.dataset.in, e.value);
                }
                else if (e.type === 'number')
                    _this.setDynamic(e.dataset.in, Number(e.value));
                else
                    _this.setDynamic(e.dataset.in, e.value);
            });
        };
        this.applyClassConditionally = function (element, className, evaluator) {
            if (evaluator)
                element.classList.add(className);
            else
                element.classList.remove(className);
        };
        this.updateBindings = function () {
            _this.updateInputBindings();
            _this.updateOutwardBindings();
        };
        this.updateOutwardBindings = function () {
            var _a;
            if (!((_a = _this.config) === null || _a === void 0 ? void 0 : _a.precomputeBindings)) {
                _this.scanBindings();
            }
            _this.appliedBindings.forEach(function (b) { return b.action(); });
        };
        this.bindInputEvents = function () { return _this.loopByQuery('[data-in]', function (e) {
            e.addEventListener('change', function () { return _this.updateBindings(); });
            e.addEventListener('blur', function () { return _this.updateBindings(); });
            if (e.dataset.immediate === 'true')
                e.addEventListener('keyup', function () { return _this.updateBindings(); });
        }); };
        this.initializeListener = function () {
            var _a;
            _this.bindInputEvents();
            _this.updateBindings();
            if ((_a = _this.config) === null || _a === void 0 ? void 0 : _a.precomputeBindings) {
                _this.scanBindings();
            }
        };
        this.scanBindings = function () {
            _this.appliedBindings = [];
            var _loop_1 = function (bindingName) {
                var action = _this.outwardBindingActions[bindingName];
                _this.loopByQuery("[data-" + bindingName + "]", function (element) {
                    var getter = _this.compileGetter(element.dataset[_this.toCamelCase(bindingName)]);
                    _this.appliedBindings.push({
                        element: element,
                        action: function () { return action(element, getter.call(_this.scope)); }
                    });
                });
            };
            for (var _i = 0, _a = Object.keys(_this.outwardBindingActions); _i < _a.length; _i++) {
                var bindingName = _a[_i];
                _loop_1(bindingName);
            }
        };
        this.initialize = function () {
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', _this.initializeListener);
            }
            else {
                _this.initializeListener();
            }
            _this.registerDefaultOutwardBindings();
        };
        this.registerOutwardBinding = function (dataAttribute, bindingAction) {
            _this.outwardBindingActions[dataAttribute] = bindingAction;
        };
        this.registerDefaultOutwardBindings = function () {
            _this.registerOutwardBinding('display', function (e, v) { return e.innerHTML = v; });
            _this.registerOutwardBinding('min', function (e, v) { return e.min = v; });
            _this.registerOutwardBinding('max', function (e, v) { return e.max = v; });
            _this.registerOutwardBinding('disable', function (e, v) { return e.disabled = v || false; });
            _this.registerOutwardBinding('out', function (e, v) { return e.value = v; });
            _this.registerOutwardBinding('class-condition', function (e, v) { return _this.applyClassConditionally(e, e.dataset.class, v || false); });
            _this.registerOutwardBinding('hide', function (e, v) {
                e.hidden = v;
                e.setAttribute('aria-hidden', (!!v).toString());
            });
            _this.registerOutwardBinding('show', function (e, v) {
                e.hidden = !v;
                e.setAttribute('aria-hidden', (!!!v).toString());
            });
            _this.registerOutwardBinding('min-length', function (e, v) { return e.minLength = v; });
            _this.registerOutwardBinding('max-length', function (e, v) { return e.maxLength = v; });
            _this.registerOutwardBinding('required', function (e, v) { return e.required = v; });
            _this.registerOutwardBinding('placeholder', function (e, v) { return e.placeholder = v; });
            _this.registerOutwardBinding('checked', function (e, v) { return e.checked = v; });
            _this.registerOutwardBinding('step', function (e, v) { return e.step = v; });
            _this.registerOutwardBinding('title', function (e, v) { return e.title = v; });
            _this.registerOutwardBinding('href', function (e, v) { return e.href = v; });
        };
        this.toCamelCase = function (kebabCase) { return kebabCase
            .split('-')
            .map(function (item, index) { return index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item; })
            .join(""); };
        this.root = root || document;
        this.scope = scope || window;
        this.initialize();
    }
    return GravyBinder;
}());
exports.GravyBinder = GravyBinder;
;
